import { useTranslation } from 'react-i18next';

import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import ServiceRecordOverviewCard from './ServiceRecordOverviewCard';

const ServiceRecordOverviewPage = () => {
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:verification.service_record.overview.meta.title')} />
      <ServiceRecordOverviewCard />
    </ContentLayout>
  );
};

export default ServiceRecordOverviewPage;
